import { render } from "./loading.vue?vue&type=template&id=0a4154f3"
const script = {}
script.render = render

export default script